import { mapActions, mapGetters } from 'vuex'
import { eventBus } from '@/main'

export default {
    computed: {
        ...mapGetters({
            collegeCardsLocalSettingsReceived: 'localSettings/CollegeCardLocalSettings',
        }),
        HasCollegeCard() { return this.collegeCard?.ID != null; },
        HasCollegeCardOptedIn() { return this.collegeCardOptIn?.OptedIn == true; },
    },
    methods: {
        ...mapActions({
            FetchCollegeCardLocalSettings: 'localSettings/FetchCollegeCardLocalSettings',
            FetchLatestStudentCollegeCardByStudentReference: 'collegeCard/FetchLatestStudentCollegeCardByStudentReference',
            FetchStudentCollegeCardOptInByStudentID: 'collegeCard/FetchStudentCollegeCardOptInByStudentID',
            UpsertStudentCollegeCardOptIn: 'collegeCard/UpsertStudentCollegeCardOptIn',
        }),
        GetLocalSetting(key) { return this.localSettings?.keyValuePairs[key] || null; },
        LoadCollegeCardsLocalSettings() {
            this.FetchCollegeCardLocalSettings()
                .then(() => this.collegeCardsLocalSettings = CoalesceJSON(this.collegeCardsLocalSettingsReceived, {}))
                .catch(error => eventBus.$emit('alert:error', error));
        },
        LoadCollegeCard(studentReference) {
            this.loadingCollegeCard = true;
            this.FetchLatestStudentCollegeCardByStudentReference({ StudentReference: studentReference })
                .then(response => {
                    this.collegeCard = CoalesceJSON(response, {});
                    eventBus.$emit('college-card-fetch:success');
                })
                .catch(error => eventBus.$emit('alert:error', error))
                .finally(() => this.loadingCollegeCard = false);
        },
        LoadCollegeCardOptIn(studentID) {
            this.loadingCollegeCardOptIn = true;
            this.FetchStudentCollegeCardOptInByStudentID({ StudentID: studentID })
                .then(response => {
                    this.collegeCardOptIn = CoalesceJSON(response, {});
                    eventBus.$emit('college-card-opt-in-fetch:success');
                })
                .catch(error => eventBus.$emit('alert:error', error))
                .finally(() => this.loadingCollegeCardOptIn = false);
        },
        SaveCollegeCardOptIn(studentID, optIn) {
            eventBus.$emit('college-card-opt-in-save:started');
            this.UpsertStudentCollegeCardOptIn({
                StudentID: studentID,
                OptIn: optIn
            })
                .then(response => {
                    eventBus.$emit('alert:success', response);
                    eventBus.$emit('college-card-opt-in-save:success');
                })
                .catch(error => eventBus.$emit('college-card-opt-in-save:failed', error))
                .finally(() => eventBus.$emit('college-card-opt-in-save:finished'));
        },
    }
};
function CoalesceJSON(object, returnObject) {
    if (object == null) return returnObject;
    else if (typeof object == 'object') return object;
    else return JSON.parse(object);
};
